import { useEffect, useMemo } from "react";
import Lenis from "lenis";
import { THEMES } from "@/themes";
import Frame from "@/components/invite/Frame";
import Hero from "@/components/invite/Hero";
import Marquee from "@/components/invite/Marquee";
import Details from "@/components/invite/Details";
import RsvpForm from "@/components/invite/RsvpForm";
import Footer from "@/components/invite/Footer";

function pickTheme() {
  const forced = parseInt(new URLSearchParams(window.location.search).get("tema") || "", 10);
  if (forced >= 1 && forced <= THEMES.length) return THEMES[forced - 1];
  const saved = localStorage.getItem("ss-theme");
  if (saved !== null && THEMES[+saved]) return THEMES[+saved];
  const idx = Math.floor(Math.random() * THEMES.length);
  localStorage.setItem("ss-theme", String(idx));
  return THEMES[idx];
}

export default function Invite() {
  const theme = useMemo(pickTheme, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div
      className={`theme-${theme.id} relative`}
      style={{ ...theme.vars, background: "var(--bg)", color: "var(--ink)", minHeight: "100vh" }}
      data-testid="invite-page"
      data-theme={theme.id}
    >
      {theme.id === "bronze" && <div className="rays" />}
      <Frame />
      <div className="relative z-10">
        <Hero />
        <Marquee />
        <Details />
        <RsvpForm />
        <Footer />
      </div>
      <div className="grain" />
    </div>
  );
}
